var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M42 23.808c0-3.993-3.196-7.23-7.139-7.23H7.14C3.196 16.579 0 19.816 0 23.809V34.77C0 38.764 3.196 42 7.139 42H34.86C38.804 42 42 38.764 42 34.771V23.808zM39.62 34.77c0 2.662-2.13 4.82-4.759 4.82H7.14c-2.629 0-4.76-2.158-4.76-4.82V23.808c0-2.662 2.131-4.82 4.76-4.82H34.86c2.629 0 4.76 2.158 4.76 4.82V34.77z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.263,
    height: 2.211,
    x: 14,
    y: 34,
    fill: "#FFF",
    rx: 1.105
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(7 22)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 0.737,
    y: 0.105,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 8.474,
    y: 0.105,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 16.211,
    y: 0.105,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 23.947,
    y: 0.105,
    rx: 1.105
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(7 27)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 0.737,
    y: 0.737,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 8.474,
    y: 0.737,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 16.211,
    y: 0.737,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.421,
    height: 2.211,
    x: 23.947,
    y: 0.737,
    rx: 1.105
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11.053 0c.072 13.896 11.052 5.694 11.052 16.579"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/Keyboard.5b95c437814a2f7bf3f24ffce6e18a26.svg";
export { ForwardRef as ReactComponent };